import { createApp, ref } from 'vue'
import AppLoading from 'components/AppLoading.vue'

let loadingSpinnerInstance = null
const isActive = ref(false)

function show(options = {}) {
  if (!loadingSpinnerInstance) {
    const container = document.createElement('div')
    document.body.appendChild(container)
    loadingSpinnerInstance = createApp(AppLoading).mount(container)
  }
  isActive.value = true
  loadingSpinnerInstance.show(options)
}

function hide() {
  if (loadingSpinnerInstance) {
    isActive.value = false
    loadingSpinnerInstance.hide()
  }
}

export default {
  show,
  hide,
}
